export const _charCount = () => {
    $.fn.extend({
        charLimit: function(limit, elem) {
            $(this).on("keyup keydown focus", function() {
                setCount(this, elem);
            });

            function setCount(src, elem) {
                var chars = src.value.length;
                if (chars > limit) {
                    src.value = src.value.substr(0, limit);
                    chars = limit;
                }
                elem.html(limit - chars);
            }
            setCount($(this)[0], elem);
        }
    });
};
